import Marquee from "react-fast-marquee";

const INDUSTRIES = [
  {
    name: "Financial Services",
    src: "/industries/financial.jpg",
    alt: "Glass towers of a financial district at dusk",
    testId: "industry-frame-financial-services",
  },
  {
    name: "Healthcare & Life Sciences",
    src: "/industries/healthcare.jpg",
    alt: "Laboratory samples in a clinical research setting",
    testId: "industry-frame-healthcare-life-sciences",
  },
  {
    name: "Retail & CPG",
    src: "/industries/retail.jpg",
    alt: "Quiet interior of a retail store",
    testId: "industry-frame-retail-cpg",
  },
  {
    name: "Energy & Utilities",
    src: "/industries/energy.jpg",
    alt: "Wind turbines on open land at last light",
    testId: "industry-frame-energy-utilities",
  },
  {
    name: "Manufacturing & Supply Chain",
    src: "/industries/manufacturing.jpg",
    alt: "Precision welding on a manufacturing line",
    testId: "industry-frame-manufacturing-supply-chain",
  },
  {
    name: "Enterprise Data & Technology",
    src: "/industries/datatech.jpg",
    alt: "Server racks in a darkened data center",
    testId: "industry-frame-enterprise-data-technology",
  },
];

export default function IndustriesFilmstrip() {
  const reduced =
    typeof window !== "undefined" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  return (
    <section
      data-testid="industries-filmstrip-section"
      className="border-b border-white/10 py-10 lg:py-14 overflow-hidden"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 mb-8 flex items-baseline justify-between">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/35">
          Industries Served
        </p>
        <p className="hidden sm:block font-mono text-[10px] uppercase tracking-[0.25em] text-white/25">
          Three Decades, Six Arenas
        </p>
      </div>

      <Marquee
        speed={16}
        gradient={false}
        pauseOnHover
        play={!reduced}
        data-testid="industries-filmstrip-marquee"
      >
        {[...Array(2)].map((_, copy) =>
          INDUSTRIES.map((ind) => (
            <figure
              key={`${copy}-${ind.name}`}
              data-testid={copy === 0 ? ind.testId : undefined}
              aria-hidden={copy > 0}
              className="group relative mx-4 lg:mx-6 w-64 sm:w-80 lg:w-[24rem] shrink-0"
            >
              <div className="relative aspect-[3/2] overflow-hidden border border-white/10">
                <img
                  src={ind.src}
                  alt={ind.alt}
                  loading="lazy"
                  className="absolute inset-0 h-full w-full object-cover grayscale brightness-[0.8] contrast-[1.05] transition-[filter,transform] duration-700 ease-out group-hover:grayscale-0 group-hover:brightness-90 group-hover:scale-[1.03]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/80 via-transparent to-[#050505]/20 pointer-events-none" />
                <figcaption className="absolute bottom-0 inset-x-0 p-4 lg:p-5">
                  <span className="block h-px w-8 bg-[#E6E4D9]/50 mb-3 transition-[width] duration-500 group-hover:w-14" />
                  <span className="font-mono text-[10px] lg:text-xs uppercase tracking-[0.25em] text-[#E6E4D9]">
                    {ind.name}
                  </span>
                </figcaption>
              </div>
            </figure>
          ))
        )}
      </Marquee>
    </section>
  );
}
